import { IsEnum, IsNotEmpty, IsString } from "class-validator";

export enum PaymentMethodTypeEnumDto {
    transfer = "transfer",
    cash = "cash",
    card = "card",
    paypal = "paypal",
    other = "other",
}

export class PaymentMethodTypeDto {
    @IsEnum(PaymentMethodTypeEnumDto)
    @IsNotEmpty()
    key!: PaymentMethodTypeEnumDto;

    @IsString()
    @IsNotEmpty()
    value!: string;
}